module.exports = __webpack_public_path__ + "img/LTS_AGL.abe291e9.gif";